module.exports = __webpack_public_path__ + "static/sun-194755d11b0d7b7768c11b07cb5bb9f5.png";